import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {Util} from "../../app/util";

@Component({
    selector: 'drag-button',
    templateUrl: 'drag-button.html'
})

export class DragButton {

    public _dragTip: boolean = false;
    public _dragging: boolean = false;

    public _startX: number = 0;
    public _currentX: number = 0;
    public _left: number = 0;
    public _max: number = 0;

    public _caminho: any;
    public _bolinha: any;

    @Input('checked') public checked: boolean = false;
    @Input('tintcor') public tintcor: 'CorRoxa' | 'CorFogo' = 'CorRoxa';

    @Input('corEnabled') public corEnabled: string = 'CorRoxa';
    @Input('corDisable') public corDisable: string = 'CorDash';

    @Input('disabled') public _disabled: boolean = false;
    @Input('mode') public _mode: 'scroll' | 'clicks' = 'scroll';
    @Input('text') public _text: string = 'Arraste...';
    @Input('width') public _width: string = '220px';
    @Input('margin') public _margin: number = 2;
    @Input('ballSize') public _ballSize: number = 60;
    @Input('checkedTest') public _checkedTest: number = 0.7;

    @Input('leftText') public _leftText: string = 'NÃO';
    @Input('doneText') public _doneText: string = 'SIM';

    @Output('dragStart') public _start: EventEmitter<any> = new EventEmitter();
    @Output('dragEnd') public _end: EventEmitter<any> = new EventEmitter();

    constructor(private _element: ElementRef, public util: Util) {

    }

    ngOnInit() {

        this._bolinha = this._element.nativeElement.querySelector('.bolinha');
        this._caminho = this._element.nativeElement.querySelector('.caminho');

        if (this.checked) {
            this._bolinha.style.left = (this._caminho.offsetWidth - this._ballSize) + 'px';
        }


        if (!this.util.nativeApp()) {

            this._bolinha.addEventListener('mousedown', (event) => this._onMouseDown(event));

            this._bolinha.addEventListener('mousemove', (event) => this._onMouseMove(event));

            this._bolinha.addEventListener('mouseup', (event) => this._onMouseUp(event));

        }


        if (this.util.nativeApp()) {

            this._bolinha.addEventListener('touchstart', (event) => this._onMouseDown(event));

            this._bolinha.addEventListener('touchmove', (event) => this._onMouseMove(event));

            this._bolinha.addEventListener('touchend', (event) => this._onMouseUp(event));

        }


        setTimeout(() => {

            this._dragTip = true;
            setTimeout(() => this._dragTip = false, 800);

        }, 500);

    }

    public setChecked(checked) {

        this._bolinha.style.left = (checked ? (this._caminho.offsetWidth - this._ballSize) : 0) + 'px';
        this.checked = checked;

    }

    public _onClicks() {

        if (this._mode == 'scroll' || this._disabled) return;

        this.setChecked(!this.checked);
        this._end.emit(this);

    }

    public _onMouseDown(event) {

        if (this._disabled || this._mode == 'clicks') return;

        //console.log('mousedown:', event);
        event.stopPropagation();

        this._dragging = true;

        this._blocks();

        this._startX = (event.touches && event.touches[0].pageX ? event.touches[0].pageX : event.pageX);
        this._currentX = parseInt(this._bolinha.style.left.substr(0, this._bolinha.style.left.indexOf('px')));
        this._currentX = this._currentX ? this._currentX : 0;
        this._max = this._caminho.offsetWidth - this._ballSize;

        this._start.emit(this);

    }

    //@HostListener('document:mousemove', ['$event'])
    //@HostListener('document:touchmove', ['$event'])
    public _onMouseMove(event) {

        if (!this._dragging || this._mode == 'clicks') return;

        //console.log('mousemove:', event);
        event.stopPropagation();

        let moveu: number = (event.touches && event.touches[0].pageX ? event.touches[0].pageX : event.pageX) - this._startX;

        this._left = Math.max(Math.min(this._currentX + moveu, this._max), 0);

        this._bolinha.style.left = this._left + 'px';

    }

    //@HostListener('document:mouseup', ['$event'])
    //@HostListener('document:touchend', ['$event'])
    public _onMouseUp(event) {

        if (!this._dragging || this._mode == 'clicks') return;

        //console.log('mouseupup:', event);
        event.stopPropagation();

        this._dragging = false;

        //private renderer: Renderer2
        //this.renderer.addClass(this._bolinha, 'efeito');

        if (this._left / this._max > this._checkedTest) {
            this._bolinha.style.left = this._max + 'px';
            this.checked = true;
        }
        else {
            this._bolinha.style.left = '0px';
            this.checked = false;
        }

        this._blocks(false);

        this._end.emit(this);

    }

    public _blocks(block: boolean = true) {

        /*

        // todo: Não está bloqueando scroll mobile, PC não pode porque a tela pula

        if (this.platform.is('mobile')) {

            let scrollElems = document.querySelectorAll('.scroll-content');

            for (let a in scrollElems) {

                if (scrollElems[a].style) {
                    scrollElems[a].style['overflow-y'] = block ? 'hidden' : 'auto';
                }

            }

            document.scrollingElement.style['overflow-y'] = block ? 'hidden' : 'auto';
            document.body.style['overflow-y'] = block ? 'hidden' : 'auto';

        }

        */

    }

}



// WEBPACK FOOTER //
// ./src/components/drag-button/drag-button.ts